module.exports = __webpack_public_path__ + "img/gameboy.69a9d96d.png";